<template>
  <div class="container">
    <van-nav-bar
      title="项目详情"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <van-tabs 
      @click="changeTab"
      color="#2FAAFF"
      title-inactive-color="#474542"
      title-active-color="#2FAAFF"
      v-model="tab_active" 
      swipeable>
      <van-tab title="基本信息">
        <div class="itembox">
          <van-field input-align="right" type="textarea" rows="1" autosize :readonly="readonly" label="项目名称" v-model="objItem.communityName" placeholder="请输入项目名称" />
          <van-field v-if="readonly" type="textarea" rows="1" autosize input-align="right" readonly label="所属机构" v-model="objItem.organizationName" placeholder="" />
          <van-field v-if="!readonly" input-align="right" readonly clickable label="所属机构" :value="objItem.organizationName" placeholder="请选择所属机构" @click="showPicker" />
          <van-field input-align="right" :readonly="readonly" label="联系人" v-model="objItem.contact" placeholder="请输入联系人" />
          <van-field input-align="right" :readonly="readonly" label="手机号" v-model="objItem.mobile" type="tel" placeholder="请输入手机号" />
        </div>
        <div class="itembox">
          <van-field input-align="right" :readonly="readonly" label="管理面积" v-model="objItem.area" placeholder="请输入管理面积">
            <template #button>㎡</template>
          </van-field>
          <van-field input-align="right" :readonly="readonly" label="总户数" v-model="objItem.totalHouse" placeholder="请输入总户数" />
        </div>
        <div class="itembox">
          <van-field input-align="right" v-if="!readonly" readonly clickable label="地区" :value="objItem.address1" placeholder="请选择项目所在地区" @click="showArea" />
          <van-field input-align="right" :readonly="readonly" v-model="objItem.address" label="项目详细地址" type="textarea" maxlength="30" rows="2" autosize show-word-limit  placeholder="请输入项目详细地址" />
        </div>

        <div class="btnbox" v-if="!readonly">
          <van-button type="info" size="large" @click="saveInfo">保存</van-button>
        </div>
      </van-tab>
      <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="name"
          @cancel="onCancel"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-popup v-model="showAreaPopup" :close-on-click-overlay='false' round position="bottom">
        <van-area title="" :area-list="areaList" @confirm="setAddress" @cancel="onCancel" />
      </van-popup>
      <van-tab :disabled="!readonly" title="计费信息">
        <div class="cellbox">
          <div class="cell menubox flex">
            <div @click="changeType(1)" :class="typeActive == 1?'btn btnActive':'btn'">自行车充电</div>
            <div @click="changeType(2)" :class="typeActive == 2?'btn btnActive':'btn'">三轮车充电</div>
            <div @click="changeType(3)" :class="typeActive == 3?'btn btnActive':'btn'">四轮车充电</div>
          </div>
          <div class="cell flex">
            <div>计费类型</div>
            <div>{{billData.chargeCostDesc}}</div>
          </div>
          <div class="cell flex">
            <div>刷卡模式</div>
            <div>{{billData.chargeModeDesc}}</div>
          </div>
        </div>
        <div class="cellbox">
          <div class="cell flex blod">
            <div class="width33">功率</div>
            <div class="width33">时间</div>
            <div class="width33">价格</div>
          </div>
          <div class="cell flex" v-for="(item,index) in billData.powers" :key="index">
            <div class="width33">{{item.pMin}}~{{item.pMax}}W</div>
            <div class="width33">1小时</div>
            <div class="width33">{{item.unitPrice}}元</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import { areaList } from '@vant/area-data';
  import {NavBar,Icon,Toast,Loading,Picker,Field,Popup,Button,Tab,Tabs,Area} from 'vant';
  export default {
    data() {
      return {
        areaList,
        showPopup:false,
        showAreaPopup:false,
        typeActive:1,
        tab_active: 0,
        readonly: false,
        communityId:'',
        objItem:{
          name:'',
          communityName: '',
          organizationId:'',
          organizationName: '',
          contact:'',
          mobile:'',
          area:'',
          totalHouse:'',
          address:'',
          address1:'',
        },
        billData:"",
        billObj1:{},
        billObj2:{},
        billObj3:{},
        columns:[],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
      [Field.name]:Field,
      [Picker.name]:Picker,
      [Popup.name]:Popup,
      [Tab.name]:Tab,
      [Tabs.name]:Tabs,
      [Area.name]:Area,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html",query:{}})
      },
      changeType(type){
        this.typeActive = type;
        if(type == 1){
          this.billData = this.billObj1;
        }else if(type == 2){
          this.billData = this.billObj2;
        }else{
          this.billData = this.billObj3;
        }
      },
      changeTab(){},
      onClickLeft() {
        this.$router.back();
      },
      getbilling(){
        axios.get("/community/getbilling?communityId="+this.communityId,{
        }).then((res)=>{
          var billData = res.data;
          billData.forEach((item)=>{
            if(item.deviceType == 1){
              this.billObj1 = item
            }else if(item.deviceType == 2){
              this.billObj2 = item
            }else if(item.deviceType == 3){
              this.billObj3 = item
            }
          })
          this.billData = this.billObj1;
        })

        axios.get("/community/get?communityId="+this.communityId,{
        }).then((res)=>{
          this.objItem = res.data;
        })
      },
      getjgList(){
        axios.get("/community/getorganization",{
        }).then((res)=>{
          var columns = [];
          res.data.forEach(item=>{
            columns.push({
              name: item.fullName,
              id: item.id
            })
          })
          this.columns = columns;
          console.log(this.columns)
        })
      },
      showPicker(){
        this.showPopup = true;
      },
      showArea(){
        this.showAreaPopup = true;
      },
      setAddress(e){
        console.log(e)
        this.objItem.provinceCode = e[0].code;
        this.objItem.cityCode = e[1].code;
        this.objItem.countyCode = e[2].code;
        this.objItem.address1 = e[0].name + e[1].name +e[2].name;
        this.showAreaPopup = false;
      },
      onCancel(){
        //取消
        this.showPopup = false;
        this.showAreaPopup = false;
      },
      onConfirm(item) {
        this.objItem.organizationId = item.id;
        this.objItem.organizationName = item.name;
        this.showPopup = false;
      },
      saveInfo(){
        if(!this.objItem.communityName){
          Toast("请输入项目名称");
          return;
        }else if(!this.objItem.organizationName){
          Toast("请选择所属机构");
          return;
        }else if(!this.objItem.contact){
          Toast("请输入联系人");
          return;
        }else if(!this.objItem.mobile){
          Toast("请输入手机号");
          return;
        }else if(!this.objItem.area){
          Toast("请输入管理面积");
          return;
        }else if(!this.objItem.totalHouse){
          Toast("请输入总用户");
          return;
        }else if(!this.objItem.address1){
          Toast("请选择项目所在地区");
          return;
        }else if(!this.objItem.address){
          Toast("请输入项目具体位置");
          return;
        }
        this.objItem.name = this.objItem.communityName;
        axios.post("/community/create",this.objItem).then((res)=>{
          if(res.isSuccess){
            Toast.success('添加成功');
          }
        })
      },
    },
    computed:{
    },
    created () {
      if(this.$route.query.communityId){
        this.communityId = this.$route.query.communityId;
        this.readonly = true
        this.getbilling();
      }
      this.getjgList();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F6F7F8}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #F6F7F8;
  }
  .block{
    background: #fff;
    margin-bottom: 16px;
  }

  .cellbox{
    padding: 0 16px;
    background: #fff;
    margin-bottom: 12px;
    .cell{
      width: 100%;
      padding: 10px 16px;
      border-bottom: 1px solid #F0F4F7;
    }
  }
  .btnbox{
    margin-top: 50px;
    padding: 0 50px;
  }
  .menubox{
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    .btn{
      width: 100px;
      text-align: center;
      border-radius: 6px;
      background: #fff;
      padding: 4px 0;
      border: 1px solid #5BA7FC;
    }
  }
  .btnActive{
    background: #5BA7FC !important;
    color: #fff;
  }
  .itembox{margin-bottom: 12px;}
  .width33{width: 33%;text-align: center;}
</style>
